"use strict";

_theme.Reward = (function(){
  const modalSignin = document.getElementById("rModal");
  const modalRegister = document.getElementById("srModal");
  if(!modalSignin || !modalRegister) return;
  const marketingInputs = modalRegister.querySelectorAll('[name="marketing"]');
  const marketingMainInputs = modalRegister.querySelector('[name="customer[accepts_marketing]"]');
  const triggerRegisterModalBtns = document.querySelectorAll('[data-reward-signup]');
  const triggerSignInModalBtns = document.querySelectorAll('[data-reward-signin]');
  const modalCloseBtns = document.querySelectorAll("[data-modalclose]");
  const showRecoverPswdFormzBtn = document.querySelector('#rModal .showRecoverPasswordForm');
  const cancelrecoverPswdFormBtn = document.querySelector('#rModal .cancel_text');
  const rewardCardBtn = document.querySelector('#reward-page .reward-card:nth-child(1) a.reward-card-btn');
  const recoverPswdSection = document.querySelector('#Rewrecover_password');

  function init(){
    triggerRegisterModalBtns.forEach(function(btn){
      btn.addEventListener("click",function (evt) {
        evt.preventDefault();
        toggleSignUpModel(true);
        setTimeout(function(){
          _theme.focusTrap($(modalRegister), function(){
            toggleSignUpModel();
            $(btn).focus();
          });
        }, 250);
      });
    });

    triggerSignInModalBtns.forEach(function(btn){
      btn.addEventListener("click",function (evt) {
        evt.preventDefault();
        toggleSignInModel(true);
        setTimeout(function(){
          _theme.focusTrap($(modalSignin), function(){
            toggleSignInModel();
            $(btn).focus();
          });
        }, 250);
      });
    });

    modalCloseBtns.forEach(function(closeBtn, index){
      closeBtn.addEventListener("click",function (evt) {
        evt.preventDefault();
        const isLoginModal = evt.target.classList.contains('rClose');
        const isRegisterModal = evt.target.classList.contains('srClose');
        toggleSignInModel();
        toggleSignUpModel();
        if(isLoginModal) triggerSignInModalBtns[0].focus();
        if(isRegisterModal) triggerRegisterModalBtns[0].focus();
      });
    });

    marketingInputs.forEach(function(input){
      input.addEventListener('change', function(evt){
        var inputVal = this.value.toLowerCase().trim();
        if(inputVal === 'yes'){
          marketingMainInputs.disabled = false;
        } else {
          marketingMainInputs.disabled = true;
        }
      });
    });

    window.onclick = function(event) {
      if (event.target ==  modalSignin) {
        toggleSignInModel();
      }
       if (event.target ==  modalRegister) {
        toggleSignUpModel();
      }
    }

    showRecoverPswdFormzBtn && showRecoverPswdFormzBtn.addEventListener('click', function(evt){
      const loginContent = document.querySelector('#rModal .rModal-content');
      const recoverPswdContent = document.querySelector('#rModal #Rewrecover_password');
      if(loginContent) loginContent.style.display = 'none';
      if(recoverPswdContent) recoverPswdContent.style.display = 'block';
      _theme.focusTrap($('#Rewrecover_password'),function() {
        // modalSignin
      });
    });
    cancelrecoverPswdFormBtn && cancelrecoverPswdFormBtn.addEventListener('click', function(evt){
      const loginContent = document.querySelector('#rModal .rModal-content');
      const recoverPswdContent = document.querySelector('#rModal #Rewrecover_password');
      if(loginContent) loginContent.style.display = 'block';
      if(recoverPswdContent) recoverPswdContent.style.display = 'none';
      showRecoverPswdFormzBtn && showRecoverPswdFormzBtn.focus();
      // _theme.focusTrap($('#rModal .rModal-content'),function() {
      // });
    });
    rewardCardBtn && rewardCardBtn.addEventListener('click', function(evt){
      const loginContent = document.querySelector('#rModal .rModal-content');
      const recoverPswdContent = document.querySelector('#rModal #Rewrecover_password');
      if(loginContent) loginContent.style.display = 'block';
      if(recoverPswdContent) recoverPswdContent.style.display = 'none';
    });
  }

  function toggleSignInModel(show){
    if(show){
      if(modalRegister) modalRegister.classList.remove('active');
      if(modalSignin) modalSignin.classList.add('active');
      if(_theme.isMobile) {
        $('*').not($('#rModal').find('*')).not('#rModal').not($('#rModal').parents()).attr('aria-hidden','true');
      }
    } else {
      if(modalSignin) modalSignin.classList.remove('active');
      if(_theme.isMobile) {
        $('*').not($('#rModal').find('*')).not('#rModal').not($('#rModal').parents()).removeAttr('aria-hidden');
      }
    }
  }

  function toggleSignUpModel(show){
    if(show){
      if(modalSignin) modalSignin.classList.remove('active');
      if(modalRegister) modalRegister.classList.add('active');
      if(_theme.isMobile) {
        $('*').not($('#rModal').find('*')).not('#rModal').not($('#rModal').parents()).attr('aria-hidden','true');
      }
    } else {
      if(modalRegister) modalRegister.classList.remove('active');
      if(_theme.isMobile) {
        $('*').not($('#rModal').find('*')).not('#rModal').not($('#rModal').parents()).removeAttr('aria-hidden');
      }
      
    }
  }

  return {init: init}
})();

window.addEventListener('DOMContentLoaded', function(event){
  if(_theme.Reward && _theme.Reward.init) _theme.Reward.init();
});